import React, { Component } from 'react';

class FlagChoice extends Component {
  constructor(props) {
    super(props);
    const {countries, onSubmit} = props;
    this.onSubmit = onSubmit;
    this.countries = countries;
    this.state = {
      country: -1,
    };
  }
  render() {
    const labelStyle = {
      marginRight: '15px',
    };
    return (
      <form onSubmit={(e) => {
        e.preventDefault();
        this.onSubmit(Number(this.state.country));
      }}>
        {this.countries.map((c, i) => {
          return (
            <label key={c.name} style={labelStyle}>
              <input
                type="radio"
                name="country"
                value={i}
                onChange={(e) => {
                  this.setState({[e.target.name]: e.target.value});
                }}/>
              {' ' + c.name}
            </label>
          );
        })}
        <button className="btn">Guess</button>
      </form>
    );
  }
}

export default FlagChoice;



// WEBPACK FOOTER //
// ./src/FlagChoice.jsx